import React from 'react'
import lockScreenIcon from '../assets/images/lock_screen.svg'

const ScreenLock: React.FC = () => {
  return (
    <div className="fixed inset-0 z-[9999] bg-flutter flex items-center justify-center">
      <div className="self-stretch inline-flex flex-col justify-center items-center gap-4 overflow-hidden">
        <div className="size-8 relative overflow-hidden">
          <img 
            src={lockScreenIcon} 
            alt="Lock Screen" 
            className="w-full h-full object-contain"
          />
        </div>
        <div className="text-center justify-start text-text-primary text-base font-medium font-['IBM_Plex_Sans_Arabic'] leading-6 line-clamp-1">
          هذا النظام غير مدعوم على الشاشات الصغيرة
        </div>
      </div>
    </div>
  )
}

export default ScreenLock

